<template>
  <div class="row">
    <div class="col col-12">
      <form>
        <!-- <div class="form-group row">
        <label class="col-sm-3 col-form-label">{{ $t("lang") }}</label>
        <div class="col-sm-9">
          <input type="text" disabled="disabled" class="form-control" v-model="lang.lang" />
        </div>
      </div> -->
        <div class="form-check abc-checkbox form-check-inline py-2">
          <input
            class="form-check-input"
            type="checkbox"
            :id="'visible-' + lang.lang"
            v-model="lang.visible"
          />
          <label class="form-check-label" :for="'visible-' + lang.lang">
            {{ $t("visible") }}
          </label>
        </div>
        <div class="form-group row">
          <label class="col-sm-5 col-form-label"
            >{{ $t("full_name") }} (<span class="text-success">{{
              $t("prefix")
            }}</span
            >, <span class="text-warning">{{ $t("name") }}</span
            >, <span class="text-danger">{{ $t("suffix") }}</span
            >)</label
          >
          <div class="col-sm-7 my-auto">
            <span
              v-show="
                lang.name_prefix !== null && lang.name_prefix !== undefined
              "
              class="text-success"
              >{{ lang.name_prefix + " " }}</span
            >
            <span
              v-show="lang.name !== null && lang.name !== undefined"
              class="text-warning"
              >{{ lang.name + " " }}</span
            >
            <span
              v-show="
                lang.name_suffix !== null && lang.name_suffix !== undefined
              "
              class="text-danger"
              >{{ lang.name_suffix + " " }}</span
            >
          </div>
        </div>
        <div v-show="checkSync()" class="row">
          <div class="col-4">
            <div class="tooltip">
              <i
                class="fa"
                :class="{
                  'fa-check text-success': checkSyncLang(
                    'lang_' + lang.lang + '_name_prefix'
                  ),
                  'fa-warning text-danger': !checkSyncLang(
                    'lang_' + lang.lang + '_name_prefix'
                  ),
                }"
              ></i>
              <span class="tooltiptext">{{
                textLangTooltip("lang_" + lang.lang + "_name_prefix")
              }}</span>
            </div>
          </div>
          <div class="col-4">
            <div class="tooltip">
              <i
                class="fa"
                :class="{
                  'fa-check text-success': checkSyncLang(
                    'lang_' + lang.lang + '_name'
                  ),
                  'fa-warning text-danger': !checkSyncLang(
                    'lang_' + lang.lang + '_name'
                  ),
                }"
              ></i>
              <span class="tooltiptext">{{
                textLangTooltip("lang_" + lang.lang + "_name")
              }}</span>
            </div>
          </div>
          <div class="col-4">
            <div class="tooltip">
              <i
                class="fa"
                :class="{
                  'fa-check text-success': checkSyncLang(
                    'lang_' + lang.lang + '_name_suffix'
                  ),
                  'fa-warning text-danger': !checkSyncLang(
                    'lang_' + lang.lang + '_name_suffix'
                  ),
                }"
              ></i>
              <span class="tooltiptext">{{
                textLangTooltip("lang_" + lang.lang + "_name_suffix")
              }}</span>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-4">
            <div class="row">
              <label class="col-sm-4 col-form-label">{{ $t("prefix") }}</label>
              <input
                :name="'lang' + lang.lang + 'name_prefix'"
                type="text"
                class="col-sm-8 form-control"
                v-model="lang.name_prefix"
              />
            </div>
          </div>
          <div class="col-4">
            <div class="row">
              <div class="col-sm-4">
                <div class="row">
                  <label class="col-sm-12 col-form-label"
                    >{{ $t("name") }} *</label
                  >
                  <small
                    v-show="errors.has('lang_name_' + lang.lang)"
                    class="col-12 text-danger"
                  >
                    {{ $t("field_required") }}
                  </small>
                </div>
              </div>
              <input
                :name="'lang_name_' + lang.lang"
                type="text"
                class="col-sm-8 form-control"
                v-model="lang.name"
                v-validate="{
                  required: lang.visible === true || lang.visible === 1,
                }"
              />
            </div>
          </div>
          <div class="col-4">
            <div class="row">
              <label class="col-sm-4 col-form-label">{{ $t("suffix") }}</label>
              <input
                type="text"
                class="col-sm-8 form-control"
                v-model="lang.name_suffix"
              />
            </div>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-sm-3">
            <div class="row">
              <label class="col-sm-12 col-form-label"
                >{{ $t("product_description") }} *</label
              >
              <small
                v-show="errors.has('lang_description_' + lang.lang)"
                class="col-12 text-danger"
              >
                {{ $t("field_required") }}
              </small>
            </div>
          </div>

          <div class="col-sm-8">
            <textarea
              :name="'lang_description_' + lang.lang"
              style=""
              size="1000"
              type="text"
              class="form-control"
              v-model="lang.description"
              v-validate="{
                required: lang.visible === true || lang.visible === 1,
              }"
              rows="15"
            ></textarea>
          </div>
          <div class="col-sm-1 my-auto">
            <div v-show="checkSync()" class="tooltip">
              <i
                class="fa"
                :class="{
                  'fa-check text-success': checkSyncLang(
                    'lang_' + lang.lang + '_description'
                  ),
                  'fa-warning text-danger': !checkSyncLang(
                    'lang_' + lang.lang + '_description'
                  ),
                }"
              ></i>
              <span class="tooltiptext">{{
                textLangTooltip("lang_" + lang.lang + "_description")
              }}</span>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-3 col-form-label">{{
            $t("product_ingredients")
          }}</label>
          <div class="col-sm-8">
            <textarea
              style=""
              size="1000"
              type="text"
              class="form-control"
              v-model="lang.composition"
              rows="15"
            ></textarea>
          </div>
          <div class="col-sm-1 my-auto">
            <div v-show="checkSync()" class="tooltip">
              <i
                class="fa"
                :class="{
                  'fa-check text-success': checkSyncLang(
                    'lang_' + lang.lang + '_composition'
                  ),
                  'fa-warning text-danger': !checkSyncLang(
                    'lang_' + lang.lang + '_composition'
                  ),
                }"
              ></i>
              <span class="tooltiptext">{{
                textLangTooltip("lang_" + lang.lang + "_composition")
              }}</span>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-sm-3">
            <div class="row">
              <label class="col-12 col-form-label"
                >{{ $t("availability") }} *</label
              >
              <small
                v-show="errors.has('lang_availability_' + lang.lang)"
                class="col-12 text-danger"
              >
                {{ $t("field_required") }}
              </small>
            </div>
          </div>

          <div class="col-sm-8 d-flex flex-row">
            <div
              class="mx-2"
              v-for="(element, key) in this.availability"
              :key="'availabilityData' + key"
            >
              <input
                class=""
                type="radio"
                :id="'availability-' + lang.lang + '-' + key"
                :name="'lang_availability_' + lang.lang"
                :value="lang.application"
                @change="updatedAvailability(element.key)"
                :checked="checkSelected(element)"
                v-validate="{
                  required: lang.visible === true || lang.visible === 1,
                }"
              />
              <label
                class="mx-2"
                :for="'availability-' + lang.lang + '-' + key"
                >{{ element.name }}</label
              >
            </div>
          </div>
          <div class="col-sm-1 my-auto">
            <div v-show="checkSync()" class="tooltip">
              <i
                class="fa"
                :class="{
                  'fa-check text-success': checkSyncLang(
                    'lang_' + lang.lang + '_application'
                  ),
                  'fa-warning text-danger': !checkSyncLang(
                    'lang_' + lang.lang + '_application'
                  ),
                }"
              ></i>
              <span class="tooltiptext">{{
                textLangTooltip("lang_" + lang.lang + "_application")
              }}</span>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VNFRProductFormsLang',
  props: {
    availability: {
      type: Array,
      required: true
    },
    lang: {
      type: Object,
      required: true
    }
  },
  data() {
    return {}
  },
  watch: {
    'lang.visible'() {
      this.$validator.reset()
    }
  },
  created() {},
  methods: {
    checkSync() {
      return this.$parent.$parent.checkSync()
    },
    checkSyncLang( name ) {
      return this.$parent.$parent.checkSyncElement( name )
    },
    textLangTooltip( name ) {
      return this.$parent.$parent.textSyncElement( name )
    },
    updatedAvailability( key ) {
      const value = key.replaceAll( '_', ' ' ).toLowerCase()
      this.lang.application = value.charAt( 0 ).toUpperCase() + value.slice( 1 )
    },
    checkSelected( element ) {
      return (
        this.lang.application !== '' &&
        this.lang.application !== null &&
        this.lang.application !== undefined &&
        element.key === this.lang.application.replace( /\s+/g, '_' ).toLowerCase()
      )
    }
  }
}
</script>
